import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { SwalAlert } from "../../components/index";
import { useSavedJob } from "../../actions/homeActions";
export default () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loadingapi, setLoadingapi] = useState(false);
  const [hasmorepgae, sethasmorepgae] = useState(false);
  const [allSevedJobs, setAllSevedJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const userId = localStorage.getItem("userId");
  const user = useSelector((state) => state.app.userData.userData);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const {
    data: jobsSavedJobs,
    isLoading,
    isError,
    error,
  } = useSavedJob(userId, user?.talent?.id, currentPage);

  useEffect(() => {
    if (jobsSavedJobs) {
      sethasmorepgae(jobsSavedJobs?.has_more_pages);
      setAllSevedJobs((prevjob) => {
        const newjob = jobsSavedJobs?.job_applies?.map((j) => j.job) || [];
        const uniqueJobs = [...prevjob, ...newjob].reduce((acc, job) => {
          if (!acc.some((j) => j.id === job.id)) {
            acc.push(job);
          }
          return acc;
        }, []);
        return uniqueJobs;
      });
    }
  }, [jobsSavedJobs]);
  
  const handleJobClick = (id) => {
    navigate("/job-details");
    dispatch({
      type: "UPDATE_JOB_ID_DATA",
      payload: { jobId: id },
    });
  };

  const mutation = useMutation({
    mutationFn: async (deletesavedJobData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.delete(`${baseURL}/api/v2/saved-jobs`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        data: deletesavedJobData,
      });
      return data;
    },
    onSuccess: (data) => {
      SwalAlert(data?.status, data?.message, "success");
      setLoadingapi(false);
      queryClient.invalidateQueries(["jobsSavedJobs"]);
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
      setLoadingapi(false);
    },
  });
  const handledeleteJobClick = (id) => {
    setLoadingapi(true);
    const userId = localStorage.getItem("userId");
    mutation.mutate({
      job_id: id,
      user_id: userId,
    });
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }
  return {
    jobsSavedJobs,
    allSevedJobs,
    handleJobClick,
    isLoading,
    hasmorepgae,
    loadingapi,
    handledeleteJobClick,
    setCurrentPage,
  };
};
